module.exports = __webpack_public_path__ + "img/14.636e1aea.png";